import React, { useState, useEffect, useRef } from "react";
import { TableBody, TableRow, TableCell } from "@material-ui/core";
import useTable from "../useTable";
import { Mensaje, MensajeSiNo } from "../mensajes";
import axios from "axios";
import { Torta } from "../graficos/graficos";
import CartasAgentes from "../agentes/cartasAgentes";
import { Toasts } from "../toasts";
import { GestionarExpendedor } from "./modalExpendedor";
import { Dimmer } from "../spinner";

const TablaExpendedores = () => {
  const op = require("../../../public/modulos/datos");
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  const accopexpendios =
    localStorage.getItem("accopexpendios") !== "undefined"
      ? JSON.parse(localStorage.getItem("accopexpendios"))
      : "1111";

  const headCells = [
    {
      id: "codigo",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "COD.",
      textAlign: "center",
    },
    {
      id: "nombre",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "NOMBRE / RAZÓN SOCIAL",
      textAlign: "center",
    },
    {
      id: "rif",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "CED. / RIF. / SUC.",
      textAlign: "center",
    },
    {
      id: "estatus",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "ESTATUS",
      textAlign: "center",
    },
    {
      id: "opciones",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: " OPCIONES",
      textAlign: "center",
    },
  ];

  const colores = [
    "#17a2b8",
    "#ffae00",
    "#dc3545",
    "#BDB76B",
    "#7B68EE",
    "#4B0082",
    "#00ffff",
    "#0080ff",
    "#0000ff",
    "#8000ff",
    "#ff00ff",
    "#ff0080",
    "#ff0045",
    "#ffff33",
    "#7B6444",
    "#008f39",
  ];

  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mostrar2, setMostrar2] = useState(false);
  const [mostrar4, setMostrar4] = useState(false);
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [expendedor, setExpendedor] = useState([]);
  const [represent, setRepresent] = useState();
  const [operacion, setOperacion] = useState(1);
  const [ciudades, setCiudades] = useState();
  const [total, setTotal] = useState(0);
  const [activos, setActivos] = useState(0);
  const [inactivos, setInactivos] = useState(0);
  const [municipios, setMunicipios] = useState([]);
  const [municipiosEx, setMunicipiosEx] = useState([]);
  const [municipiosData, setMunicipiosData] = useState([]);
  const [datos, setDatos] = useState([]);
  const [colorG, setColorG] = useState([]);
  const [credito, setCredito] = useState();
  const txtBuscador = useRef();
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [toast, setToast] = useState({
    mostrar: false,
    mensaje: "",
    titulo: "",
  });
  const { TblContainer, TblHead, recordsAfterPagingAndSorting, TblPagination } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;
    let st = "";
    setFilterFn({
      fn: (items) => {
        if (target.value === "") return items;
        else
          return items.filter((x) => {
            st = x.statusente === "51" ? "activo" : "inactivo";
            if (
              x.idagente.includes(target.value) ||
              x.nombre.toLowerCase().includes(target.value.toLowerCase()) ||
              x.rif.toLowerCase().includes(target.value.toLowerCase()) ||
              st.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
      },
    });
  };

  const selectMunicipio = () => {
    let campos = "*";
    let nomtab = "municipio";
    let nomid = "idestado";
    let id = "18";
    let endpoint = `${op.conexion}/api/consulta/modelirows?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setMunicipios(response.data);
          getExpendedores();
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const getExpendedores = () => {
    setActivate(true);

    let campos = `trim(a.nombre) as nombre, a.idagente, trim(a.rif) as rif
    , trim(a.nroresolucionexpe) as nroresolucionexpe, trim(a.nrolicenciaexpe) as nrolicenciaexpe,
     a.statusexpe, a.municipio, a.ciudad, trim(m.nombre) as municipios, a.sucursal, a.convenioexpe`;
    let nomtab =
      "agente as a inner join municipio as m on a.municipio=m.idmunicipio";
    let condi = `a.expendedor=true`;
    let orden = "idagente asc";

    let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?&campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          let total = 0,
            activos = 0,
            inactivos = 0,
            conteo = 0,
            indice = 0;
          const idmunicipioss = [];
          const results = [];
          const element = [];
          const unicos = [];
          const color = [];

          if (response.data.length > 0) {
            setRecords(response.data);
            txtBuscador.current.focus();

            for (let i = 0; i < response.data.length; i++) {
              if (parseInt(response.data[i].statusexpe) === 51) {
                idmunicipioss.push(response.data[i]);
              }
            }

            for (var i = 0; i < idmunicipioss.length; i++) {
              const elemento = idmunicipioss[i].municipios;

              for (let j = 0; j < response.data.length; j++) {
                if (
                  idmunicipioss[i].municipios === response.data[j].municipios &&
                  parseInt(response.data[j].statusexpe) === 51
                ) {
                  conteo += 1;
                  if (indice !== i) {
                    indice = i;
                    conteo = 1;
                  }
                }
              }

              if (!unicos.includes(idmunicipioss[i].municipios)) {
                unicos.push(elemento);
                results.push(conteo);
                color.push(colores[i]);
                element.push({
                  nombre: idmunicipioss[i].municipios,
                  valor: conteo,
                  color: colores[i],
                });
              }
            }

            for (let i = 0; i < response.data.length; i++) {
              total += 1;
              if (parseInt(response.data[i].statusexpe) === 51) {
                activos += 1;
              }
              if (parseInt(response.data[i].statusexpe) === 52) {
                inactivos += 1;
              }
            }

            setTotal(total);
            setActivos(activos);
            setInactivos(inactivos);
            setColorG(color);
            setMunicipiosEx(unicos);
            setMunicipiosData(results);
            setDatos(element);
          } else {
            setRecords([]);
            txtBuscador.current.focus();
            setTotal(0);
            setActivos(0);
            setInactivos(0);
            setMunicipiosEx([]);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const getExpendedor = (id) => {
    setActivate(true);

    let endpoint = `${op.conexion}/api/agente/veragente/${id}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.idagente > 0) {
            setExpendedor(response.data);
            seleccionarRepre(response.data);
            selectCiudad(response.data.municipio);
            setCredito(response.data.credito);
          } else {
            seleccionarRepre(response.data);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const selectCiudad = (id) => {
    let campos = "*";
    let nomtab = "ciudad";
    let nomid = "idmunicipio";

    let endpoint = `${op.conexion}/api/consulta/modelirows?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setCiudades(response.data);
          setMostrar2(true);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarRepre = (data) => {
    let campos = "*";
    let nomtab = "persona";
    let nomid = "cedula";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${data.reprelegal}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.cedula > 0) {
            setRepresent(response.data);
            setMostrar2(true);
          } else {
            setMostrar2(true);
          }

          setActivate(false);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const gestionarExpendedor = (op, id) => (e) => {
    blanquear();
    if (op === 4) {
      if (accopexpendios.substring(0, 1) !== "0") {
        setOperacion(4);
        getExpendedor(id);
      } else {
        setToast({
          ...toast,
          mostrar: true,
          titulo: "Notificación",
          mensaje: "No Posee los Permisos para Realizar esta Acción",
        });
      }
    } else if (op === 1) {
      if (accopexpendios.substring(1, 2) !== "0") {
        setOperacion(op);
        setMostrar2(true);
      } else {
        setToast({
          ...toast,
          mostrar: true,
          titulo: "Notificación",
          mensaje: "No Posee los Permisos para Realizar esta Acción",
        });
      }
    } else if (op === 2) {
      if (accopexpendios.substring(2, 3) !== "0") {
        setOperacion(op);
        getExpendedor(id);
      } else {
        setToast({
          ...toast,
          mostrar: true,
          titulo: "Notificación",
          mensaje: "No Posee los Permisos para Realizar esta Acción",
        });
      }
    } else if (op === 3) {
      if (accopexpendios.substring(3, 4) !== "0") {
        setOperacion(op);
        getExpendedor(id);
      } else {
        setToast({
          ...toast,
          mostrar: true,
          titulo: "Notificación",
          mensaje: "No Posee los Permisos para Realizar esta Acción",
        });
      }
    }
  };

  const cerrarToast = () => {
    setToast({
      mostrar: false,
    });
  };

  const handleCancela2 = () => {
    setMostrar2(false);
  };

  const handleCloseSi = () => {
    setActivate(false);
    getExpendedor();
    setMostrar4(false);
  };

  const blanquear = () => {
    setRepresent();
  };

  useEffect(() => {
    selectMunicipio();
    setActivate(true);
  }, []);

  const data = {
    labels: municipiosEx,
    leyend: true,
    datasets: [
      {
        label: "#",
        data: municipiosData,
        backgroundColor: colorG,
        borderColor: colorG,
        borderWidth: 1,
        hoverBorderWidth: 15,
      },
    ],
  };

  const options = {
    responsive: true,
    legend: {
      position: "top",
      display: false,
    },
    title: {
      display: true,
      text: `Municipios con Expendedores Activos: ${municipiosData.length}`,
    },
  };

  return (
    <div
      className="p-0 m-0"
      style={{ backgroundColor: "#", height: "100%", width: "100%" }}
    >
      <div className="row col-md-12" style={{ margin: 0 }}>
        <div className="row col-md-12" style={{ margin: 0 }}>
          <div className="col-md-8 py-3">
            <CartasAgentes
              total={total}
              nombre={"Expendedores"}
              activos={activos}
              inactivos={inactivos}
            />
            <div className="col-12 p-2">
              <div className="row col-12 d-flex justify-content-between">
                <input
                  type="text"
                  className=" col-3 form-control form-control-sm rounded-pill"
                  ref={txtBuscador}
                  onChange={handleSearch}
                  placeholder="Buscar"
                />
                <div className="col-3 d-flex justify-content-end">
                  <button
                    onClick={gestionarExpendedor(1, "")}
                    style={{ marginBottom: "5px" }}
                    className={
                      accopexpendios.substring(1, 2) === "0"
                        ? "btn btn-sm btn-secondary rounded-circle"
                        : "btn btn-sm btn-primary rounded-circle"
                    }
                  >
                    <i className="fas fa-plus"></i>{" "}
                  </button>
                </div>
              </div>
            </div>
            <div className="col-md-12" style={{ margin: "auto" }}>
              <TblContainer>
                <TblHead />

                <TableBody>
                  {records &&
                    recordsAfterPagingAndSorting().map((item, index) => (
                      <TableRow key={index} style={{ padding: "0" }}>
                        <TableCell
                          className="align-baseline"
                          style={{ textAlign: "center" }}
                        >
                          {item.idagente}
                        </TableCell>
                        <TableCell
                          className="align-baseline"
                          style={{ textAlign: "center , width: '270px' }" }}
                        >
                          {item.nombre}
                        </TableCell>
                        <TableCell
                          className="align-baseline"
                          style={{ textAlign: "center" }}
                        >
                          {item.rif + " - " + item.sucursal}
                        </TableCell>
                        <TableCell
                          className="align-baseline"
                          style={{ textAlign: "center", alignItems: "center" }}
                        >
                          {item.statusexpe === "51" ? (
                            <span className="text-success2 mayuscula fw-bold">
                              Activo
                            </span>
                          ) : (
                            <span className="text-danger2 mayuscula fw-bold">
                              Inactivo
                            </span>
                          )}
                        </TableCell>
                        <TableCell
                          className="align-baseline"
                          style={{ textAlign: "center" }}
                        >
                          <button
                            onClick={gestionarExpendedor(4, item.idagente)}
                            className={
                              accopexpendios.substring(0, 1) === "0"
                                ? "btn btn-sm  btn-secondary rounded-circle ml-2"
                                : "btn btn-sm  btn-info rounded-circle ml-2"
                            }
                          >
                            <i className="fas fa-eye"></i>{" "}
                          </button>
                          <button
                            onClick={gestionarExpendedor(2, item.idagente)}
                            className={
                              accopexpendios.substring(2, 3) === "0"
                                ? "btn btn-sm  btn-secondary rounded-circle ml-2"
                                : "btn btn-sm  btn-warning rounded-circle ml-2"
                            }
                          >
                            <i className="fa fa-edit"></i>{" "}
                          </button>
                          <button
                            onClick={gestionarExpendedor(3, item.idagente)}
                            className={
                              accopexpendios.substring(3, 4) === "0"
                                ? "btn btn-sm  btn-secondary rounded-circle ml-2"
                                : "btn btn-sm  btn-danger rounded-circle ml-2"
                            }
                          >
                            <i className="fa fa-trash"></i>{" "}
                          </button>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </TblContainer>
              <TblPagination />
            </div>
          </div>
          <div className="col-md-4 py-3">
            <Torta data={data} height={200} options={options} datos={datos} />
          </div>
        </div>
      </div>
      <GestionarExpendedor
        show={mostrar2}
        operacion={operacion}
        expendedor={expendedor}
        represent={represent}
        ciudades={ciudades}
        onHideCancela={handleCancela2}
        onHideRenderizar={selectMunicipio}
      />

      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
      <Dimmer active={activate} />
      <Toasts
        show={toast.mostrar}
        titulo={toast.titulo}
        mensaje={toast.mensaje}
        onHideCancela={cerrarToast}
      />
    </div>
  );
};
export default TablaExpendedores;



// WEBPACK FOOTER //
// ./src/components/agentes/tablaExpendedor.js